import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=72902d3a&scoped=true&"
import script from "./MyFavorites.vue?vue&type=script&lang=js&"
export * from "./MyFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72902d3a",
  null
  
)

export default component.exports